import { useGetContext } from '@api/lendingAPI/lapiHooks';
import { fetchGetOnlineAccount } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import {
    getReconsentConnections,
    ReconsentConnection
} from './getReconsentConnections';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import { getBanksFromContext } from '../getBanksFromContext';

export const useGetReconsentConnections = (): ReconsentConnection[] => {
    const stateKey = useStateKey();

    const { data: onlineAccountsResponse } = useQuery({
        queryKey: ['online_accounts', stateKey],
        queryFn: () => fetchGetOnlineAccount({ stateKey }),
        suspense: true,
        useErrorBoundary: (_error, query) => !query.state.data
    });

    const { data: context } = useGetContext();

    return getReconsentConnections(
        onlineAccountsResponse,
        getBanksFromContext(context)
    );
};
